/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useState} from 'react';
import {toAbsoluteUrl} from "../../../../_metronic/helpers";
import {useNavigate, useParams} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {getChangeEmailCode} from "../core/_requests";
import {Button, Spinner} from "react-bootstrap";
import {useThemeMode} from "../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

const  ConfirmEmail =() =>{
    const [loading,setLoading] = useState<boolean>(false)
    const [status,setStatus] =useState<any>(null)
    const {code} = useParams()
    const navigate = useNavigate()
    const {mode} = useThemeMode()
    useEffect(() => {
        const loadChangeMail =  async () => {
            setLoading(true)
            const response:any = await  getChangeEmailCode(code || '')
            setStatus(response?.Status)
            /* if(response?.Status?.MessageType === 'Success'){
               let {data: userProfileData,Status}=  await getUserProfileData()
               if(Status?.Success){
                   dispatch(setProfileUser(userProfileData))
               }
            }*/
            setLoading(false)
        }
        loadChangeMail()
    }, [code]);

    if (loading) {
        return (
            <div  data-bs-theme={mode} className='d-flex flex-column align-items-center justify-content-center flex-root'>
                <Button variant='primary' disabled>
                    <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' />
                    <FormattedMessage id='LOADING' />
                </Button>
            </div>
        )
    }
    return (
        <div  data-bs-theme={mode} className='d-flex flex-column align-items-center justify-content-center flex-root'>
            <a href='#' className='mb-7'>
                <img src={toAbsoluteUrl('/media/images/Logo-Dark.png')} className='h-100px theme-light-show' />
                <img src={toAbsoluteUrl('/media/images/Logo-Light.png')} className='h-100px theme-dark-show' />
            </a>
            <div className='w-lg-500px bg-white rounded shadow-sm p-5 p-lg-10'>
                <div className='d-flex flex-column align-items-center'>
                    {status?.MessageType === 'Success' && (
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='32px'
                            height='32px'
                            viewBox='0 0 32 32'
                            version='1.1'
                        >
                            <g id='surface1'>
                                {/* style={" stroke:none;fill-rule:nonzero;fill:#50cd89;fill-opacity:1;"} */}
                                <path
                                    fill='#50cd89'
                                    d='M 16 30 C 8.269531 30 2 23.730469 2 16 C 2 8.269531 8.269531 2 16 2 C 23.730469 2 30 8.269531 30 16 C 30 23.730469 23.730469 30 16 30 Z M 16 32 C 24.835938 32 32 24.835938 32 16 C 32 7.164062 24.835938 0 16 0 C 7.164062 0 0 7.164062 0 16 C 0 24.835938 7.164062 32 16 32 Z M 16 32 '
                                />
                                <path
                                    fill='#50cd89'
                                    d='M 21.941406 9.941406 C 21.925781 9.953125 21.914062 9.96875 21.898438 9.984375 L 14.953125 18.835938 L 10.769531 14.644531 C 10.175781 14.09375 9.257812 14.113281 8.683594 14.683594 C 8.113281 15.253906 8.097656 16.175781 8.648438 16.765625 L 13.941406 22.058594 C 14.226562 22.347656 14.621094 22.503906 15.027344 22.5 C 15.433594 22.492188 15.820312 22.316406 16.097656 22.019531 L 24.082031 12.039062 C 24.648438 11.445312 24.632812 10.507812 24.046875 9.933594 C 23.460938 9.359375 22.523438 9.363281 21.941406 9.941406 Z M 21.941406 9.941406 '
                                />
                            </g>
                        </svg>
                    )}
                    {status?.MessageType === 'Error' && (
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='32px'
                            height='32px'
                            viewBox='0 0 32 32'
                            version='1.1'
                        >
                            <g id='surface1'>
                                <path
                                    fill='#850911'
                                    d='M 16 30 C 8.269531 30 2 23.730469 2 16 C 2 8.269531 8.269531 2 16 2 C 23.730469 2 30 8.269531 30 16 C 30 23.730469 23.730469 30 16 30 Z M 16 32 C 24.835938 32 32 24.835938 32 16 C 32 7.164062 24.835938 0 16 0 C 7.164062 0 0 7.164062 0 16 C 0 24.835938 7.164062 32 16 32 Z M 16 32 '
                                />
                                <path
                                    fill='#850911'
                                    d='M 9.292969 9.292969 C 9.480469 9.105469 9.734375 9 10 9 C 10.265625 9 10.519531 9.105469 10.707031 9.292969 L 16 14.585938 L 21.292969 9.292969 C 21.683594 8.902344 22.316406 8.902344 22.707031 9.292969 C 23.097656 9.683594 23.097656 10.316406 22.707031 10.707031 L 17.414062 16 L 22.707031 21.292969 C 23.097656 21.683594 23.097656 22.316406 22.707031 22.707031 C 22.316406 23.097656 21.683594 23.097656 21.292969 22.707031 L 16 17.414062 L 10.707031 22.707031 C 10.316406 23.097656 9.683594 23.097656 9.292969 22.707031 C 8.902344 22.316406 8.902344 21.683594 9.292969 21.292969 L 14.585938 16 L 9.292969 10.707031 C 9.105469 10.519531 9 10.265625 9 10 C 9 9.734375 9.105469 9.480469 9.292969 9.292969 Z M 9.292969 9.292969 '
                                />
                            </g>
                        </svg>
                    )}
                    <div style={{padding: '20px'}} className="fs-5 fw-bolder">
                        {status?.Message}
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                        <button onClick={()=>navigate("/home")} type='submit' className='btn btn-primary'>
                            <span className='indicator-label'>J'ai compris</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmEmail;